const SDK_ACCESS_TOKEN_LOCAL_STORAGE_KEY = '[wishi-sdk-token]'; // This should optimally come from env

export const getSDKAccessToken = () =>
    localStorage.getItem(SDK_ACCESS_TOKEN_LOCAL_STORAGE_KEY) ?? ``;
export const setSDKAccessToken = (token: string) =>
    localStorage.setItem(SDK_ACCESS_TOKEN_LOCAL_STORAGE_KEY, token);
export const deleteSDKAccessToken = () =>
    localStorage.removeItem(SDK_ACCESS_TOKEN_LOCAL_STORAGE_KEY);
